<template>
  <el-drawer
    :title="title"
    :visible="showDrawer"
    :before-close="handleClosed"
    size="70%"
    ref="drawerRef"
    v-bind="$attrs"
    @closed="handleClosed"
    @open="handleOpenDrawer"
  >
    <el-row>
      <EditContact :ContactData="model" :innerDrawer="innerDrawer" />
      <el-col>
        <el-form
          :model="model"
          label-position="left"
          size="mini"
          label-width="120px"
        >
          <h2 style="padding-left: 30px">{{ model.CompanyName }}</h2>

          <el-input
            v-if="isEditing"
            placeholder="Nuevo nombre del prospecto"
            v-model="model.CompanyName"
            style="width: 500px; padding-left: 30px"
          >
          </el-input>
          <hr />

          <el-row
            :gutter="20"
            class="mt-20"
            type="flex column"
            style="padding-left: 30px"
          >
            <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
              <el-form-item label="Codigo">
                <el-input
                  v-model="model.ContactCode"
                  :disabled="true"
                ></el-input>
              </el-form-item>

              <el-form-item label="Telefono">
                <el-input
                  v-model="model.PhoneNumber"
                  :disabled="!isEditing"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="Vendedor"
                prop="SellerId"
                :rules="[{ required: true, message: 'Vendedor requerido' }]"
              >
                <SellerSelector
                  v-model="model.SellerId"
                  style="width: 100%"
                  :disabled="!isEditing"
                />
              </el-form-item>

              <el-form-item
                label="Serv. cliente"
                prop="CustomerServiceId"
                :rules="[
                  {
                    required: true,
                    message: 'Servicio al cliente requerido'
                  }
                ]"
              >
                <CustomerServiceSelector
                  v-model="model.CustomerServiceId"
                  style="width: 100%"
                  :disabled="!isEditing"
                />
              </el-form-item>

              <el-form-item
                label="Sop. ventas"
                prop="SupportSellerId"
                :rules="[
                  { required: true, message: 'Soporte de venta requerido' }
                ]"
              >
                <SupportSellerSelector
                  v-model="model.SupportSellerId"
                  style="width: 100%"
                  :disabled="!isEditing"
                />
              </el-form-item>
            </el-col>

            <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
              <el-form-item label="Email">
                <el-input
                  v-model="model.Email"
                  :disabled="!isEditing"
                ></el-input>
              </el-form-item>

              <el-form-item label="Direccion">
                <el-input
                  v-model="model.ContactAddress"
                  :disabled="!isEditing"
                ></el-input>
              </el-form-item>

              <el-form-item label="Ciudad">
                <el-input
                  v-model="model.City"
                  :disabled="!isEditing"
                ></el-input>
              </el-form-item>

              <el-form-item label="Zona">
                <el-input
                  v-model="model.Zone"
                  :disabled="!isEditing"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
              <el-form-item label="Cant. Empleados">
                <el-input-number
                  v-model="model.EmployeesAmount"
                  :min="0"
                  :disabled="!isEditing"
                ></el-input-number>
              </el-form-item>

              <el-form-item label="Cant. de PCs">
                <el-input-number
                  v-model="model.ComputersAmount"
                  :min="0"
                  :disabled="!isEditing"
                ></el-input-number>
              </el-form-item>

              <el-form-item label="Cant. Vehiculos">
                <el-input-number
                  v-model="model.VehiculesAmount"
                  :min="0"
                  :disabled="!isEditing"
                ></el-input-number>
              </el-form-item>

              <el-form-item label="Cant. Clientes">
                <el-input-number
                  v-model="model.ClientsAmount"
                  :min="0"
                  :disabled="!isEditing"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="Cant. Sucursales">
                <el-input-number
                  v-model="model.SucursalesAmount"
                  :min="0"
                  :disabled="!isEditing"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="end" :gutter="0">
            <el-button-group style="padding: 30px 30px 0 0">
              <el-button
                type="primary"
                icon="el-icon-check"
                v-if="false"
                size="mini"
                >Editar</el-button
              >

              <el-button
                :loading="requestLoading"
                type="primary"
                icon="el-icon-check"
                size="mini"
                v-else-if="isEditing"
                @click="onSubmit"
                >Guardar</el-button
              >
              <el-button
                type="info"
                v-if="isEditing"
                @click="isEditing = false"
                size="mini"
                >Cancelar</el-button
              >
            </el-button-group>
          </el-row>
          <el-row style="padding-left: 30px">
            <el-col>
              <el-tabs v-model="activeName" :before-leave="onBeforeLeave">
                <el-tab-pane label="Contactos" name="contacts">
                  <rabbey-table-3
                    ref="contacts"
                    :loading="prospectDetailLoading"
                    :data="prospectDetailContacts"
                    :columns="columnContact"
                    :actions="ActionsContact"
                    @rtable-push-action="HandelActionsContact"
                  />
                </el-tab-pane>
                <el-tab-pane label="Interacciones" name="interactions">
                  <vue-scroll>
                    <rabbey-table-3
                      ref="interactions"
                      :loading="prospectDetailLoading"
                      :data="prospectDetailInteractions"
                      :columns="columnInteractions"
                    />
                  </vue-scroll>
                </el-tab-pane>
                <el-tab-pane label="Solicitudes" name="supports">
                  <rabbey-table-3
                    ref="supports"
                    :loading="prospectDetailLoading"
                    :data="prospectDetailRequests"
                    :columns="columnSupports"
                  />
                </el-tab-pane>
              </el-tabs>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </el-drawer>
</template>

<script>
import { formatPhoneNumber } from "@/utils";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import SellerSelector from "@/components/Company/SellerSelector.vue";
import CustomerServiceSelector from "@/components/Company/CustomerServiceSelector.vue";
import SupportSellerSelector from "@/components/Company/SupportSellerSelector.vue";
import { formatDate } from "@/utils";
import EditContact from "@/components/contacts/EditContact.vue";
export default {
  name: "ProspectDetails",
  inheritAttrs: false,
  components: {
    SellerSelector,
    CustomerServiceSelector,
    SupportSellerSelector,
    EditContact
  },
  props: {
    ProspectData: {
      type: Object,
      required: true
    },
    drawer: {
      type: Boolean,
      default: false
    },
    isEditingModel: {
      type: String
    }
  },
  data() {
    return {
      isEditing: false,
      title: "Detalle de Prospecto",
      model: {
        SalesPersonCode: this.$store.state.user.user.SalesPersonCode,
        SalesPersonName: this.$store.state.user.user.SalesPersonName,
        MagycorpCompanyId: this.$store.state.user.user.CompanySelected,
        CompanyName: "",
        NewCompanyName: "",
        VatRegistrationNumber: "",
        ContactAddress: "",
        AddressTwo: "",
        City: "",
        FirstName: "",
        MiddleName: "",
        SurName: "",
        JobTitle: "",
        PhoneNumber: "",
        ExtensionNumber: "",
        MobilePhoneNumber: "",
        Email: "",
        Number: "",
        PictureDirectory: "",
        Birthday: "2020-08-13T15:54:09.551Z",
        SellerId: "",
        SupportSellerId: "",
        CustomerServiceId: "",
        isEditingModel: true
      },
      loading: false,
      requestLoading: false,
      innerDrawer: false,
      activeName: "contacts",
      labelButton: "Editar",
      contacts: [],
      columnContact: [
        {
          prop: "ContactCode",
          label: "Código"
        },
        {
          prop: "FullName",
          label: "Nombre"
        },
        {
          prop: "Email",
          label: "Email"
        },
        {
          prop: "PhoneNumber",
          label: "Telefono"
        },
        {
          prop: "MobilePhoneNumber",
          label: "Celular"
        },
        {
          prop: "LastDateModified",
          label: "Última actualizacion",
          formatter: (e) => formatDate(e.LastDateModified, "DD/MM/YYYY h:mm a")
        }
      ],
      columnInteractions: [
        {
          prop: "InteractionType",
          label: "Tipo"
        },
        // {
        //   prop: "ContactNo",
        //   label: "Contacto"
        // },
        {
          prop: "UserName",
          label: "Creado por"
        },
        {
          prop: "CreatedOn",
          label: "Fecha de creación",
          formatter: (e) => formatDate(e.CreatedOn, "DD/MM/YYYY h:mm a")
        },
        {
          prop: "Subject",
          label: "Asunto"
        },
        {
          prop: "Description",
          label: "Conclución"
        }
      ],
      columnSupports: [
        {
          prop: "Id",
          label: "NO",
          width: 80,
          sortable: true,
          fixed: true
        },
        {
          prop: "CustomerName",
          label: "Cliente",
          minWidth: 350
        },
        {
          prop: "ServiceRequestType.Description",
          label: "Solictud",
          sortable: true,
          formatter: (row) => {
            return row.ServiceRequestType
              ? row.ServiceRequestType.Description
              : "";
          },
          minWidth: 200
        },
        {
          prop: "Customer.CustomerService",
          label: "Servicio",
          formatter: ImagePerson,
          minWidth: 170
        },
        {
          prop: "AssignedTechnician.FullName",
          label: "Tecnico",
          minWidth: 250,
          formatter: ImagePerson
        },
        {
          prop: "RequestDate",
          label: "Creado",
          formatter: DatetimeFormatter,
          minWidth: 190
        },
        {
          prop: "DueDate",
          label: "Limite",
          formatter: DatetimeFormatter,
          minWidth: 190
        },
        {
          prop: "SLAHoursToRespond",
          label: "SLA",
          minWidth: 75,
          sortable: true,
          formatter: (row) => {
            return row.SLAHoursToRespond ? row.SLAHoursToRespond : "";
          }
        }
      ],
      columnAccountStatus: [
        {
          prop: "NcfNumber",
          name: "NCF"
        },
        {
          prop: "InvoiceNumber",
          name: "# Factura"
        },
        {
          prop: "InvoiceDescription",
          name: "Descriccion"
        },
        {
          prop: "InvoiceDate",
          name: "Creada",
          formatter: DatetimeFormatter,
          width: 180
        },
        {
          prop: "InvoiceDueDate",
          name: "Vence",
          formatter: DatetimeFormatter,
          width: 180
        },
        {
          prop: "InvoiceTotal",
          name: "InvoiceTotal"
        },
        {
          prop: "InvoiceDue",
          name: "InvoiceDue"
        },
        {
          prop: "ContractNumber",
          name: "ContractNumber"
        }
      ],
      columnContrats: [
        {
          prop: "No_Contrato",
          name: "No Contrato",
          width: 150
        },
        {
          prop: "Tipo_Proceso",
          name: "Periodo",
          width: 150
        },
        {
          prop: "Contract_Conditions",
          name: "Estatus"
        },
        {
          prop: "Fecha_Inicio",
          name: "Fecha inicio",
          formatter: DatetimeFormatter,
          minWidth: 190
        },
        {
          prop: "Fecha_Final",
          name: "Fecha final",
          formatter: DatetimeFormatter,
          minWidth: 190
        },
        {
          prop: "Próx_Fecha_Facturación",
          name: "Próx. fecha facturación",
          formatter: DatetimeFormatter,
          minWidth: 190
        }
      ],
      columnComplaints: [],
      prospectDetailLoading: false,
      prospectDetailContacts: [],
      prospectDetailInteractions: [],
      prospectDetailRequests: [],
      ActionsContact: [
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit"
        }
      ]
    };
  },
  methods: {
    callParametros() {},
    formatPhoneNumber,

    getContacts() {
      this.prospectDetailLoading = true;
      this.$http
        .get(
          `/api/contacts/GetContactByProspect?contactCode=${this.model.ContactCode}&companyCode=${this.currentCompany}`
        )
        .then((resp) => {
          this.prospectDetailContacts = resp.data;
          this.prospectDetailLoading = false;
        });
    },
    callContacts(resp) {
      const table = this.$refs.contacts;
      table.items = resp.data;
    },
    getInteractions() {
      this.prospectDetailLoading = true;
      let criteriaData = {
        params: {
          timeout: 3 * 60 * 1000,
          CustomerCode: this.ProspectData.ContactCode,
          CompanyId: this.currentCompany
        }
      };
      this.$http
        .get("/api/interactions/InteractionsCustomerDetails", criteriaData)
        .then((resp) => {
          // Funcion que quita los Tags de Html
          for (const i in resp.data.Items) {
            var str = resp.data.Items[i].Description.replace(
              /(<([^>]+)>)/gi,
              ""
            );
            var html = str;

            var div = document.createElement("div");
            div.innerHTML = html;
            var text = div.textContent || div.innerText || "";

            resp.data.Items[i].Description = text;
          }
          this.prospectDetailInteractions = resp.data.Items;
        })
        .finally(() => {
          this.prospectDetailLoading = false;
        });
    },
    getSupports() {
      this.prospectDetailLoading = true;
      let criteriaRequest = {
        params: {
          companyCode: this.currentCompany,
          ClientCode: this.ProspectData.ContactCode
        }
      };
      this.$http
        .get("/api/serviceRequests", criteriaRequest)
        .then((resp) => {
          this.prospectDetailRequests = resp.data.Items;
          this.prospectDetailLoading = true;
        })
        .finally(() => {
          this.prospectDetailLoading = false;
        });
    },
    getAccountStatus() {
      const currentCompany = this.currentCompany;
      const client = this.ProspectData.ClientCode;
      const table = this.$refs.account_status;
      const config = {
        params: {
          "criteria.clientCode": client,
          "criteria.companyCode": currentCompany,
          "criteria.opc": 1
        }
      };
      table.indexConfig = config;
      table.getData();
    },
    callAccountStatus(resp) {
      const table = this.$refs.account_status;
      table.items = resp.data;
    },
    getContrats() {
      const currentCompany = this.currentCompany;
      const client = this.ProspectData.ClientCode;
      const table = this.$refs.contracts;
      const config = {
        params: {
          clientCode: client,
          companyCode: currentCompany
        }
      };
      table.indexConfig = config;
      table.getData();
    },
    getComplaints() {},
    callContracts(resp) {
      const table = this.$refs.contracts;
      table.items = resp.data;
    },
    // eslint-disable-next-line no-unused-vars
    onBeforeLeave(activeName, oldActiveName) {
      this.innerDrawer = false;

      this.activeName = activeName;
      switch (activeName) {
        case "contacts": {
          this.getContacts();
          break;
        }

        case "interactions": {
          this.getInteractions();
          break;
        }

        case "supports": {
          this.getSupports();
          break;
        }

        case "account_status": {
          this.getAccountStatus();
          break;
        }

        case "contracts": {
          this.getContrats();
          break;
        }

        default:
          break;
      }
    },
    onSubmit() {
      this.requestLoading = true;
      this.$http
        .post(`/api/prospects/edit?`, this.model, {
          timeout: 3 * 60 * 1000,
          params: {
            ContactCode: this.ProspectData.ContactCode,
            SalesPersonCode: this.currentUser.PersonCode,
            id: this.ProspectData.Id
          }
        })
        .then(this.handleResponse)
        .catch(() => {
          this.requestLoading = false;
          //console.error(x)
        });
    },
    handleResponse(resp) {
      if (resp.data) {
        this.$emit("closeDrawer");
        this.drawerLoading = false;
        this.loading = false;
        this.requestLoading = false;

        this.$emit("update-data", this.model);
        this.$message({
          type: "success",
          message: "Prospecto actualizado exitosamente"
        });
      } else {
        this.$message({
          type: "error",
          message: "Hubo un error al actualizar el prospecto"
        });
      }
    },
    handleClosed() {
      this.innerDrawer = false;

      this.activeName = "contacts";
      this.prospectDetailContacts = [];
      this.prospectDetailInteractions = [];
      this.prospectDetailRequests = [];
      this.$emit("closeDrawer");
    },
    handleOpenDrawer() {
      // this.isEditing = false;
      this.model = { ...this.ProspectData };
    },
    HandelActionsContact(c) {
      switch (c.command) {
        case "edit": {
          this.innerDrawer = true;
          break;
        }
      }
    }
  },
  computed: {
    phone() {
      return this.formatPhoneNumber(this.ProspectData.PhoneNumber);
    },
    showDrawer() {
      return this.drawer;
    }
  },

  watch: {
    ProspectData() {
      if (this.isEditingModel == "true") {
        this.isEditing = true;
      } else {
        this.isEditing = false;
      }
      this.model = { ...this.ProspectData };
      this.getContacts();
    },
    isEditingModel() {
      this.console(this.isEditingModel);
    }
  }
};
</script>

<style lang="scss" scoped>
.tags span:not(:first-child) {
  margin-left: 5px;
}
</style>
